export default __webpack_public_path__ + "static/media/interview01.194413f6.jpg";